export default __webpack_public_path__ + "static/media/Rush-Wall.15db6024.jpg";